module.exports = __webpack_public_path__ + "static/media/infoIcon.b4ab0f41.svg";